import { ChipStatus } from 'components/Chip/Chip';

import { BillingPeriodUnit, SubscriptionStatus } from '../../common/contracts';

export const BILLING_PERIOD_DISPLAY_NAME = {
  [BillingPeriodUnit.DAILY]: 'Daily',
  [BillingPeriodUnit.WEEKLY]: 'Weekly',
  [BillingPeriodUnit.MONTHLY]: 'Monthly',
  [BillingPeriodUnit.YEARLY]: 'Yearly'
};

export const statusMapping: Record<string, ChipStatus> = {
  [SubscriptionStatus.ACTIVE]: 'success',
  [SubscriptionStatus.OVERDUE]: 'active',
  [SubscriptionStatus.PENDING]: 'warning',
  [SubscriptionStatus.CANCELED]: 'danger',
  [SubscriptionStatus.TRIAL]: 'optional'
};
